var playNumberRadios = Array.prototype.slice.call(document.querySelectorAll("#numberOfPlaysRadios input"));
playNumberRadios.forEach(playNumberRadio => {
    playNumberRadio.addEventListener("change", function (e) {
        var allMiniSubOptions = Array.prototype.slice.call(document.querySelectorAll('#miniSubOptions option'));
        allMiniSubOptions.forEach(chosenSub => {
            chosenSub.classList.remove("show");
            chosenSub.classList.add("hide");
        })
        var selectedMiniSubOptions = Array.prototype.slice.call(document.querySelectorAll('#miniSubOptions option[data-num-plays="' + e.target.value + '"]'));
        selectedMiniSubOptions[0].selected = true;
        selectedMiniSubOptions.forEach(chosenSub => {
            chosenSub.classList.remove("hide");
            chosenSub.classList.add("show");
        })
    });
});



// WEBPACK FOOTER //
// ./Static/javascript/pages/subs-landing.ts